import React, { useEffect, useState } from "react";
import "./manageAddress.scss";
import userActivePage from "../../../../store/userActivePage";
import {
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import addressStore from "../../../../store/addressStore";
import { LoadingButton } from "@mui/lab";

const ManageAddress = ({ isBtnContainer = true }) => {
  const isNonMobile = useMediaQuery("(max-width: 600px)");
  const params = useParams();
  const navigate = useNavigate();
  const UserActivePage = userActivePage();
  const AddressStore = addressStore();
  const [isLoading, setIsLoading] = useState(false);
  const [addressID, setAddressID] = useState(null);

  useEffect(() => {
    UserActivePage.setIsActive({ setPage: "address" });
    window.scrollTo({ top: 0 });
    if (params.id) {
      if (AddressStore.AddressForm.fullName !== "") {
        setAddressID(params.id);
      } else {
        navigate(-1);
      }
    }
  }, []);

  const CreateNewAddress = async () => {
    setIsLoading(true);
    const flag = await AddressStore.checkValidation();
    if (flag) {
      let res = false;
      if (params.id) {
        res = await AddressStore.updateUserAddress({ _id: params.id });
      } else {
        res = await AddressStore.createNewUserAddress();
      }
      if (res) navigate(-1);
    }
    setIsLoading(false);
  };

  return (
    <div className="manage-address">
      <Stack spacing={isBtnContainer ? 3 : 2}>
        <div className="title">New Address</div>
        <RadioGroup
          value={AddressStore.AddressForm.addressCategory}
          name="addressCategory"
          row
          onChange={AddressStore.setAddressForm}
        >
          <FormControlLabel value="home" control={<Radio />} label="Home" />
          <FormControlLabel value="office" control={<Radio />} label="Office" />
        </RadioGroup>
        <Stack
          spacing={isBtnContainer ? 3 : 2}
          direction={isNonMobile ? "column" : "row"}
        >
          <TextField
            name="fullName"
            type="text"
            required
            fullWidth
            label="Full Name"
            autoComplete="name"
            value={AddressStore.AddressForm.fullName}
            onChange={AddressStore.setAddressForm}
            error={AddressStore.validationAddressForm.fullName}
            helperText={
              AddressStore.validationAddressForm.fullName &&
              "Full Name is require"
            }
          />
          <TextField
            name="phoneNumber"
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            required
            fullWidth
            label="Phone Number"
            autoComplete="phone"
            value={AddressStore.AddressForm.phoneNumber}
            onChange={AddressStore.setAddressForm}
            error={AddressStore.validationAddressForm.phoneNumber}
            helperText={
              AddressStore.validationAddressForm.phoneNumber &&
              "Phone Number is require"
            }
          />
        </Stack>
        <TextField
          name="address"
          type="text"
          required
          multiline
          rows={2}
          fullWidth
          label="Address"
          autoComplete="address-line1"
          value={AddressStore.AddressForm.address}
          onChange={AddressStore.setAddressForm}
          error={AddressStore.validationAddressForm.address}
          helperText={
            AddressStore.validationAddressForm.address && "Address is require"
          }
        />

        <Stack
          spacing={isBtnContainer ? 3 : 2}
          direction={isNonMobile ? "column" : "row"}
        >
          <TextField
            name="city"
            type="text"
            required
            fullWidth
            label="Town / City"
            autoComplete="locality"
            value={AddressStore.AddressForm.city}
            onChange={AddressStore.setAddressForm}
            error={AddressStore.validationAddressForm.city}
            helperText={
              AddressStore.validationAddressForm.city &&
              "Town / City is require"
            }
          />
          <TextField
            name="state"
            type="text"
            required
            fullWidth
            label="State"
            autoComplete="address-level1"
            value={AddressStore.AddressForm.state}
            onChange={AddressStore.setAddressForm}
            error={AddressStore.validationAddressForm.state}
            helperText={
              AddressStore.validationAddressForm.state && "State is require"
            }
          />
          <TextField
            name="pincode"
            required
            fullWidth
            inputProps={{
              maxLength: 6,
              inputMode: "numeric",
              min: "0",
            }}
            label="Zip/Code"
            autoComplete="postal_code"
            value={AddressStore.AddressForm.pincode}
            onChange={AddressStore.setAddressForm}
            error={AddressStore.validationAddressForm.pincode}
            helperText={
              AddressStore.validationAddressForm.pincode &&
              "Zip/Code is require"
            }
          />
        </Stack>
        <TextField
          name="country"
          type="text"
          required
          fullWidth
          label="Country"
          disabled
          helperText="We only delivering in India."
          // autoComplete="country-name"
          value={AddressStore.AddressForm.country}
        />
        <FormControlLabel
          checked={AddressStore.AddressForm.useDefault}
          control={<Checkbox />}
          label={<p>Use this address as default.</p>}
          sx={{ maxWidth: "fit-content" }}
          onChange={(e) =>
            AddressStore.setUseDefault({ value: e.target.checked })
          }
        />
        {isBtnContainer && (
          <>
            <Divider />
            <Stack
              direction="row-reverse"
              spacing={2}
              className="btn-container"
            >
              <LoadingButton
                loading={isLoading}
                style={{ background: isLoading && "#f5f5f5f5" }}
                className="save-btn"
                variant="contained"
                onClick={CreateNewAddress}
              >
                {params.id ? <p>Save Changes</p> : <p>Create Address</p>}
              </LoadingButton>

              <Button
                className="cancel-btn"
                color="error"
                variant="outlined"
                onClick={() => navigate(-1)}
              >
                <p>Cancel</p>
              </Button>
            </Stack>
          </>
        )}
      </Stack>
    </div>
  );
};

export default ManageAddress;
